import { useI18n } from '@change-corgi/core/react/i18n';

import { usePetitionCommentsPageData } from 'src/app/pages/petition/comments/pageContext';

type Result = ModelHookResult<{
	pageTitle: string;
}>;

export function usePageMeta(): Result {
	const { translate } = useI18n();
	const {
		data: {
			petition: { ask },
		},
	} = usePetitionCommentsPageData();

	return {
		data: {
			pageTitle: [translate('fe.pages.comments.page_title'), ask].join(' · '),
		},
	};
}
